/**
 * Where the operator console and the organization apps live.
 *
 * On the fixed local preview port each app runs on its own origin
 * (43170 console, 43171 AUGI, 43173 Rookmere). Anywhere else, such as the
 * deployed build behind one host, they sit under path prefixes on the page's
 * own origin, so links stay relative.
 */
const LOCAL_CONSOLE_PORT = "43170";

function isLocalPreview(): boolean {
  if (typeof window === "undefined") {
    return true;
  }
  const { hostname, port } = window.location;
  const loopback =
    hostname === "127.0.0.1" || hostname === "localhost" || hostname === "[::1]";
  return loopback && port === LOCAL_CONSOLE_PORT;
}

const local = isLocalPreview();

/** App roots end with a slash so paths and queries append directly. */
export const CONSOLE_APP_URL = local ? "http://127.0.0.1:43170/" : "/";
export const AUGI_APP_URL = local ? "http://127.0.0.1:43171/" : "/augi/";
export const ROOKMERE_APP_URL = local ? "http://127.0.0.1:43173/" : "/rookmere/";

/** Entry screens of each workspace. */
export const WORKSPACE_LOGIN_URLS = {
  heavyRain: `${CONSOLE_APP_URL}login`,
  rookmere: `${ROOKMERE_APP_URL}login`,
  augi: `${AUGI_APP_URL}login`,
} as const;
